// extracted by mini-css-extract-plugin
export default {"customerMethodTitle":"CustomerMethod_customerMethodTitle__sr7S2"};